import { env } from '../Env.js';
import { getBasePath } from '../utils/getBasePath.js';
import { isURL, joinPath, withoutQuery } from '../utils/url.js';
import { useRouter } from './useRouter.js';
export function useActiveRoute(items = []) {
    const router = useRouter();
    const filteredItems = Array.from(items.entries()).filter(([, href]) => isHrefActive(router)(href));
    return (filteredItems.find(([, href]) => isHrefActive(router, true)(href)) ??
        filteredItems[filteredItems.length - 1] ??
        []);
}
const isHrefActive = (router, strict = false) => ({ href }) => {
    if (!href) {
        return false;
    }
    const routerHref = withoutQuery(getRouterHref(router)(href));
    return strict ? routerHref === withoutQuery(href) : routerHref.startsWith(withoutQuery(href));
};
const getRouterHref = (router) => (href) => {
    const basePath = getBasePath(env.SITE_URL);
    return isURL(href) ? router.href : joinPath(basePath, router.pathname);
};
//# sourceMappingURL=useActiveRoute.js.map